import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { CoreContentModule } from "@obg/ngx.core.content";
import { GlobalUiModule } from "@obg/ngx.ui.global";
import { GlobalUiLazyImageModule } from "@obg/ngx.ui.global.lazy-image";

import { BonusSelectionComponent } from "./bonus-selection.component";

const DIRECTIVES = [BonusSelectionComponent];

@NgModule({
	imports: [CommonModule, GlobalUiModule, GlobalUiLazyImageModule, CoreContentModule, MatButtonModule, MatCardModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class BonusSelectionUiModule {}
